import React, { FC, useCallback, useState, useEffect } from 'react';
import { IdleUserListener } from '../IdleUserListener';
import { IdleUserConfirmation } from '../IdleUserConfirmation';
import { IdleUserTimeoutProps } from './IdleUserTimeout.props';

const IdleUserTimeout: FC<IdleUserTimeoutProps> = ({
  timeoutMinutes: minutes,
  onTimeout,
  waitTimeMinutes,
}) => {
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleIdleTimeout = useCallback(() => {
    if (waitTimeMinutes === 0) {
      onTimeout();
    } else {
      setShowConfirmation(true);
    }
  }, [waitTimeMinutes, onTimeout]);

  const handleDoTimeout = useCallback(() => {
    setShowConfirmation(false);
    onTimeout();
  }, [onTimeout]);

  const handleClose = useCallback(() => {
    setShowConfirmation(false);
  }, []);

  useEffect(() => {
    let id: number;

    if (showConfirmation) {
      id = window.setInterval(() => {
        changeTitle();
      }, 1000);
    }
    return () => {
      if (id) {
        window.clearInterval(id);
        document.title = 'Global Payments';
      }
    };
  }, [showConfirmation]);

  var isOldTitle = true;
  var oldTitle = 'Global Payments';
  var newTitle = 'Logout';

  const changeTitle = () => {
    document.title = isOldTitle ? oldTitle : newTitle;
    isOldTitle = !isOldTitle;
  };
  return (
    <>
      <IdleUserListener
        timeoutMinutes={minutes}
        onTimeout={handleIdleTimeout}
        disabled={showConfirmation}
      />
      {!!waitTimeMinutes && (
        <IdleUserConfirmation
          open={showConfirmation}
          onClose={handleClose}
          onDoTimeout={handleDoTimeout}
          timeoutMinutes={minutes}
          waitTimeMinutes={waitTimeMinutes}
        />
      )}
    </>
  );
};

IdleUserTimeout.defaultProps = {
  waitTimeMinutes: 1,
};

export default IdleUserTimeout;
